import { render } from "./CalculationPageWrapper.vue?vue&type=template&id=24fbac2c&scoped=true&ts=true"
import script from "./CalculationPageWrapper.vue?vue&type=script&lang=ts"
export * from "./CalculationPageWrapper.vue?vue&type=script&lang=ts"

import "./CalculationPageWrapper.vue?vue&type=style&index=0&id=24fbac2c&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24fbac2c"]])

export default __exports__